import { Tab, Tabs } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import CoreButton from "../../../app/core/components/CoreButton/CoreButton";
import CoreSpinner from "../../../app/core/components/CoreSpinner/CoreSpinner";
import { useGetOtherServicesQuery } from "../../api/admin/altriServiziApi";
import { useGetStudioIdQuery } from "../../api/admin/gestisciStudioApi";
import { addOtherServices, removeOtherServices } from "./AltriServiziSlice";
import { SUB_ROLE } from "../../../utils/constants/profiles";

const AltriServiziPage = () => {
  const dispatch = useDispatch();

  const colorPrimary = useSelector((state) => state.app.primaryColor);
  const studioId = useSelector((state) => state.app.studioId);
  const subRole = useSelector((state) => state.app.subRole);

  const [selectedCategory, setSelectedCategory] = useState("Tutti");
  const [serviceStatus, setServiceStatus] = useState({});

  const { data, isLoading, refetch } = useGetOtherServicesQuery();

  const {
    data: datas,
    isLoading: loadingDatas,
    refetch: refetchDatas,
  } = useGetStudioIdQuery(studioId);

  useEffect(() => {
    if (
      data &&
      data.Data &&
      datas &&
      datas.Data &&
      datas.Data.adminStudioOtherServices
    ) {
      const initialStatus = {};

      if (data.Data.items) {
        data.Data.items.forEach((service) => {
          const isServiceEnabled = datas.Data.adminStudioOtherServices.some(
            (otherService) => otherService?.otherServiceId === service.id
          );
          initialStatus[service.id] = isServiceEnabled;
        });
        setServiceStatus(initialStatus);
        // setLoading(false);
      }
    }
  }, [data, datas, isLoading, refetch]);

  useEffect(() => {
    if (datas && datas.Data && datas.Data.adminStudioOtherServices) {
      setServiceStatus((prevStatus) => {
        const updatedStatus = { ...prevStatus };

        if (data && data.items) {
          data.items.forEach((service) => {
            const isServiceEnabled = datas.Data.adminStudioOtherServices.some(
              (otherService) => otherService?.otherServiceId === service.id
            );
            updatedStatus[service.id] = isServiceEnabled;
          });
        }

        return updatedStatus;
      });
    }
  }, [datas, data]);

  const handleChange = (event, newValue) => {
    setSelectedCategory(newValue);
  };

  const handleServiceButtonClick = async (OtherServiceId) => {
    try {
      const newStatus = !serviceStatus[OtherServiceId];

      if (newStatus) {
        await dispatch(
          addOtherServices({ OtherServiceId, StudioId: studioId })
        );
        toast.success(`Servizio attivato con successo`);
      } else {
        await dispatch(
          removeOtherServices({ OtherServiceId, StudioId: studioId })
        );
        toast.success(`Servizio disattivato con successo`);
      }

      refetch();
      refetchDatas();
    } catch (error) {
      if (error.response && error.response.status >= 400) {
        let errorMessage = "Errore durante l'operazione sui servizi";
        switch (error.response.status) {
          case 401:
            errorMessage = "Utente non autorizzato.";
            break;
          case 403:
            errorMessage = "Accesso vietato.";
            break;
          case 404:
            errorMessage = "Risorsa non trovata.";
            break;
          case 500:
            errorMessage = "Errore interno del server.";
            break;
          default:
            errorMessage = "Errore durante l'operazione sui servizi";
            break;
        }

        toast.error(errorMessage);
      } else if (error.payload && error.payload.Exception) {
        // Display a generic error message instead of the exception from the payload
        toast.error("Errore durante l'operazione");
      } else {
        toast.error("Errore durante l'operazione sui servizi");
      }
    }
  };

  const filteredServices =
    selectedCategory === "Tutti"
      ? data && data?.Data?.items
      : data &&
        data?.Data?.items?.filter(
          (service) => service?.category === selectedCategory
        );

  if (isLoading || loadingDatas) {
    return <CoreSpinner />;
  }

  return (
    <div className="w-full">
      <Tabs
        value={selectedCategory}
        onChange={handleChange}
        aria-label="Altri Servizi Tabs"
      >
        <Tab label="Tutti" value="Tutti" />
        <Tab label="Finanziari" value="FINANZIARI" />
        <Tab label="Pianificazione Fiscale" value="PIANIFIC_FISCALE" />
        <Tab
          label="Assistenziali e Previdenziali"
          value="ASSIST_PREVIDENZIALI"
        />
      </Tabs>

      {filteredServices?.map((service) => (
        <div className="flex py-8 items-center space-x-12" key={service.Id}>
          <div className="w-28">
            {service.iconUrl ? (
              <img
                src={service.iconUrl}
                className="w-full h-full"
                alt={service.Name}
              />
            ) : (
              <p className="text-gray">No image</p>
            )}
          </div>
          <div className="w-6/12 flex space-x-4">
            <div>
              <h3 className="m-0">{service.name}</h3>
              <p className="m-0">{service.description}</p>
              <h5 style={{ color: `${colorPrimary}` }}>
                {service.commission} €
              </h5>
            </div>
          </div>
          {subRole === SUB_ROLE.ADMIN && (
            <div className="flex items-center">
              <CoreButton
                testo={serviceStatus[service.id] ? "Disattiva" : "Attiva"}
                className={
                  serviceStatus[service.id] ? "btn-round-outline" : "btn-round"
                }
                onClick={() => handleServiceButtonClick(service.id)}
              />
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default AltriServiziPage;
